/* eslint-disable no-useless-escape */
import React, { FC, useEffect, useState } from 'react';

interface OOMailPreview {
  content: string;
}

const MailPreview: FC<OOMailPreview> = ({ content }) => {
  const [htmlContent, setHtmlContent] = useState<string | null>(null);

  useEffect(() => {
    if (content) {
      const parser = new DOMParser();
      const doc = parser.parseFromString(content, 'text/html');
      setHtmlContent(doc.body.innerHTML);
    } else {
      setHtmlContent('');
    }
  }, [content]);

  return (
    <div
      dangerouslySetInnerHTML={{ __html: htmlContent || '' }}
      className="mail-preview"
      style={{
        boxShadow: '0 2px 2px rgba(0,0,0,0.12)',
      }}
    />
  );
};

export default MailPreview;
